<script setup lang="ts">
import TheLogo from '@/components/TheLogo.vue';
import { ToastMessageOptions, ToastProps } from 'primevue/toast';
import { useRouter } from 'vue-router';
const site = import.meta.env.VITE_TOAST_SITE;
const router = useRouter();
function toGoToProfile() {
    router.push('/profile');
}
function onClose(messageObject: ToastProps) {
    const message = messageObject.message as ToastMessageOptions;
    if (message.summary === 'fill_email') {
        localStorage.setItem('isHideGoProfile', 'true');
    }
}
/**
 * Checks if the string is plain text (assuming translation keys do not contain spaces).
 * @param {string} message - The text or translation key.
 * @returns {boolean} - true if the message is plain text and should not be translated.
 */
function isPlainText(message: string): boolean {
    // Simple rule: if it contains spaces or special characters, it's likely plain text
    return /\s/.test(message) || /[^a-zA-Z0-9._]/.test(message);
}
</script>

<template>
    <Toast
        group="global"
        @close="onClose"
        :pt="{
            closeButton: {
                class: '!text-white'
            },
            message: {
                class: 'backdrop-blur-lg rounded-2xl'
            }
        }"
    >
        <template #message="slotProps">
            <div class="flex flex-auto flex-col items-start text-white">
                <div class="flex items-center gap-2 text-white">
                    <TheLogo class="size-10" />
                    <div class="flex flex-col">
                        <span class="font-bold text-white">
                            {{ `${site} ${$t('status')}` }}
                        </span>
                        <b v-if="slotProps.message.severity === 'error'">
                            {{ $t(`errors.${slotProps.message.summary}`) }}
                        </b>
                        <b v-else-if="slotProps.message.severity === 'success'">
                            {{ $t(`success.${slotProps.message.summary}`) }}
                        </b>
                        <b v-else-if="slotProps.message.severity === 'info'">
                            {{ $t(`${slotProps.message.summary}`) }}
                        </b>
                    </div>
                </div>
                <div class="my-2 text-lg font-medium">
                    <span v-if="isPlainText(slotProps.message.detail)">
                        {{ slotProps.message.detail }}
                    </span>
                    <span v-else-if="slotProps.message.severity === 'error'">
                        {{ $t(`errors.${slotProps.message.detail}`) }}
                    </span>
                    <span v-else-if="slotProps.message.severity === 'success'">
                        {{ $t(`success.${slotProps.message.detail}`) }}
                    </span>
                    <span v-else>
                        {{ $t(`${slotProps.message.detail}`) }}
                    </span>
                </div>
                <Button severity="info" v-if="slotProps.message.summary === 'fill_email'" :label="$t('go_to_profile')" @click="toGoToProfile" />
            </div>
        </template>
    </Toast>
</template>
